import { groupBy, orderBy } from "lodash";
import { Item__Atividades, ItemPropriedades } from "../../../../../../../services/atividades/GET";
import { unidade_medida_local } from "../../../../visaoGeral/components/insumosPrecisao/meta";
import { numeroMilhar } from "../../../../../../../utils";
import { obterCodInsumo } from "../../../../linhaDoTempo/components/cadastro/components/executada/components/execucoesTable/meta";
import { typeInsumoAdd } from "../../../../linhaDoTempo/components/cadastro";
import { estruturaTodasAtvs } from "../../atvsTodas/meta/estrutura_todas_atvs";
import dayjs from "dayjs";
import { Item__EquipeCliente } from "../../../../../../../services/Equipe/GET";


function normalizarQuantidade(quantidade: number, cod_medida: number, cod_tipo: number) {
    //L -> L
    if (cod_medida === 1) {
        return { quantidade: quantidade, medida: 'L', desc: `${numeroMilhar(quantidade)} L` };
    }
    //mL -> L
    if (cod_medida === 2) {
        return { quantidade: quantidade / 1000, medida: 'L', desc: `${numeroMilhar(quantidade / 1000)} L` };
    }
    //KG -> KG
    if (cod_medida === 3 || cod_medida === 6) {
        if (quantidade >= 1000) {
            return { quantidade: quantidade / 1000, medida: 't', desc: `${numeroMilhar(quantidade / 1000)} t` };
        }
        return { quantidade: quantidade, medida: 'Kg', desc: `${numeroMilhar(quantidade)} Kg` };
    }
    //g -> KG
    if (cod_medida === 4) {
        if (quantidade < 1000) {
            return { quantidade: quantidade, medida: 'g', desc: `${numeroMilhar(quantidade)} g` };
        }
        return { quantidade: quantidade / 1000, medida: 'Kg', desc: `${numeroMilhar(quantidade / 1000)} Kg` };
    }
    //t -> t
    if (cod_medida === 7) {
        return { quantidade: quantidade, medida: 't', desc: `${numeroMilhar(quantidade)} t` };
    }

    return { quantidade: quantidade, medida: null, desc: `${numeroMilhar(quantidade)}` };

}

//TYPES
export type typeAtvsPorTalhao = {
    cod_talhao: number;
    nome_talhao: string;
    lista_atividades: {
        data_inicio_planejada: string | null;
        data_final_planejada: string | null;
        nome_atv_planejada: string;
        dias: number;
        lista_execucoes: {
            data_inicio: string | null;
            data_final: string | null;
            area: number;
            cod_usuario: number;
            nome_usuario: string;
            pontualidade: string;
        }[];
    }[];
}

export type typeEstruturaAtvsExecutadas = {
    cod_propriedade: number;
    nome_propriedade: string;
    lista_atividades_por_talhao: typeAtvsPorTalhao[];
};

export function estruturaAtvsExecutadas(
    data_atividades: Item__Atividades[],
    data_propriedades: ItemPropriedades[],
    data_equipe_cliente: Item__EquipeCliente[],
    cod_propriedade_selecionada: number,
    cod_talhao_selecionado: number,
    cod_subarea_selecionada: number,
): typeEstruturaAtvsExecutadas[] {
    const atvs_ativas = data_atividades.filter(i => i.delete_time === null);

    const estrutura_planejadas = estruturaTodasAtvs(data_atividades, data_propriedades, [], cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada);

    const atvs_executadas = atvs_ativas.filter(i => i.cod_tipo === 2);

    const estrutura_executadas = estrutura_planejadas.map(i => {
        return {
            ...i,
            lista_atividades_por_talhao: i.lista_atividades_por_talhao.map(j => {
                return {
                    ...j,
                    lista_atividades: (j.lista_atividades ?? []).map(k => {
                        const lista_execucoes = (atvs_executadas ?? []).filter(le => le.cod_atividade === k.cod);
                        return {
                            nome_atv_planejada: k.descricao,
                            data_inicio_planejada: k.data_inicio,
                            data_final_planejada: k.data_final,
                            dias: Number(k.dias),
                            lista_execucoes: listaAtvsExecutadas(lista_execucoes, data_equipe_cliente, k.data_inicio, k.data_final)
                        }
                    })
                }
            })
        }
    });

    if (cod_propriedade_selecionada) {
        const filtro_propriedade = estrutura_executadas.filter(i => i.cod_propriedade === cod_propriedade_selecionada) ?? [];

        if (cod_talhao_selecionado) {
            if (cod_subarea_selecionada) {
                return filtro_propriedade?.map(i => {
                    return {
                        ...i,
                        lista_atividades_por_talhao: i.lista_atividades_por_talhao.filter(i => i.cod_talhao === cod_subarea_selecionada) ?? []
                    }
                })
            }
            return filtro_propriedade?.map(i => {
                return {
                    ...i,
                    lista_atividades_por_talhao: i.lista_atividades_por_talhao.filter(i => i.cod_talhao === cod_talhao_selecionado) ?? []
                }
            });
        }
        return filtro_propriedade;
    }

    return estrutura_executadas ?? []
};


function listaAtvsExecutadas(lista_execucoes: Item__Atividades[], equipe: Item__EquipeCliente[], data_inicio_planejada: string | null, data_final_planejada: string | null) {

    const estrutura_execucoes = (lista_execucoes ?? []).map(i => {
        return {
            andamentos: (i.andamentos ?? []).map(anda => {
                const data_execucao = anda.data_final ?? i.data_final;
                return {
                    pontualidade: obterPontualidade(data_inicio_planejada, data_final_planejada, data_execucao)?.descricao,
                    data_inicio: anda.data_inicio,
                    data_final: data_execucao,
                    area: anda.area,
                    cod_usuario: anda.cod_usuario,
                    nome_usuario: anda.cod_usuario ? (equipe ?? [])?.find(eqp => eqp.cod_func === anda.cod_usuario)?.usuario_nome : anda.operador_nome,
                }
            }),

        }
        //@ts-ignore
    }).map(i => i.andamentos).flat()


    return estrutura_execucoes ?? [];
}


function obterPontualidade(data_inicial: string | null, data_final: string | null, DATA_EXECUCAO: string | null): { status: string, color_light: string, cor: string, descricao: string } | null {

    if (!data_inicial || !DATA_EXECUCAO) return { status: '', color_light: 'lightgray', cor: 'lightgray', descricao: '' };

    let data_prazo_inicial = data_inicial;
    let data_prazo_final = data_final ?? data_inicial;

    let is_adiantado = DATA_EXECUCAO < data_prazo_inicial && DATA_EXECUCAO < data_prazo_final;
    let is_no_prazo = DATA_EXECUCAO >= data_prazo_inicial && DATA_EXECUCAO <= data_prazo_final;
    let is_atrasado = DATA_EXECUCAO > data_prazo_final && DATA_EXECUCAO > data_prazo_inicial;

    let diferenca_dias = dayjs(data_prazo_final).diff(DATA_EXECUCAO, "day");
    let dias = diferenca_dias === 1 ? 'dia' : 'dias';

    if (is_adiantado) {
        return { status: `${Math?.abs(diferenca_dias)} ${dias} Adiantado`, color_light: 'rgba(255, 172, 0, 0.2)', cor: '#cb9700', descricao: 'Adiantada' }
    }
    if (is_no_prazo) {
        return { status: `No prazo`, color_light: 'rgba(41, 233, 34, 0.07)', cor: '#29e922', descricao: 'No prazo' }
    }
    if (is_atrasado) {
        return { status: `${Math?.abs(diferenca_dias)} ${dias} Atrasado`, color_light: 'rgba(220, 20, 60, 0.1)', cor: '#DC143C', descricao: 'Atrasada' }
    }

    return { status: 'indefinido', color_light: 'lightgray', cor: 'lightgray', descricao: 'Indefinido' };
}